import React from "react";
import { Flex } from "rebass/styled-components";

export function FloatingNavContainer(props) {
  return (
    <Flex variant="floatingNav" {...props}>
      {props.children}
    </Flex>
  );
}
